
    const original = "<svg\n   width=\"20\"\n   height=\"20\"\n   viewBox=\"0 0 20 20.000001\"\n   version=\"1.1\"\n   id=\"svg1\"\n   xmlns=\"http://www.w3.org/2000/svg\"\n   xmlns:svg=\"http://www.w3.org/2000/svg\">\n  <defs\n     id=\"defs1\" />\n  <g\n     id=\"g2\">\n    <path\n       style=\"fill:#855cd6;fill-opacity:1;stroke:none;stroke-width:0;stroke-linecap:round;stroke-dasharray:none;stroke-opacity:1\"\n       id=\"path4-4\"\n       d=\"M 16.028651,3.6928799 H 3.2361401 L 9.6323958,-7.3857598 Z\"\n       transform=\"matrix(0,1.5634147,-1.8052758,0,6.6666667,-5.0594288)\" />\n  </g>\n</svg>\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
